import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import PromotionalBannerDetailComponent from "../../Components/PromotionalBannerDetailComponent/PromotionalBannerDetailComponent";
import {
  Apiurl,
  GetLocalStorageParsed,
  parseData,
  secretKey,
  stringifyData,
} from "../utils/page";
import axios from "axios";
import CryptoJS from "crypto-js";
import Loader from "../../Components/Loader/Loader";
import { toast } from "react-toastify";


const PromotionalBannerDetail = () => {
  const FetchToken = GetLocalStorageParsed("AuthToken");

  const [formData, setFormData] = useState({
    Username: "",
    UserEmail: "",
    PhoneNumber: "",
    Address: "",
    Query: "",
    BannerId: "",
  });
  const [errorMessage, setErrorMessage] = useState({
    Username: "",
    UserEmail: "",
    PhoneNumber: "",
    Address: "",
    Query: "",
  });
  const [loading, setLoading] = useState("");
  const [promotionalDetail, setPromotionalDetail] = useState("");
  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [bannerUrl, setBannerUrl] = useState();

  const handleGetPromotionalDetail = (item) => {
    setLoading("getPro");

    const urlId = decodeURIComponent(window.location.pathname?.split("/")?.[2]); // Decode URL
    // const urlId = decodeURIComponent(window.location.hash?.split("/")?.[2]); // Decode URL
    const bytes = CryptoJS.AES.decrypt(urlId, secretKey());
    const originalId = bytes.toString(CryptoJS.enc.Utf8);

    const data = {
      id: originalId,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${item || loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Customer/GetPromotionalBannersById`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setPromotionalDetail(data);
        const imagePath = data?.BannerUrl?.replace(/^\"|\"$/g, ""); // Remove surrounding quotes
        setBannerUrl(`${Apiurl()}/${imagePath}`, "imagePath");
        setLoading("");
      })
      .catch((error) => {});
  };
  useEffect(() => {
    handleGetPromotionalDetail();
  }, []);
  const Validations = () => {
    const errors = {};

    if (!formData?.Username || formData?.Username?.trim() === "") {
      errors.Username = "Name is required";
    }

    if (!formData?.UserEmail || formData?.UserEmail?.trim() === "") {
      errors.UserEmail = "Email is required";
    }
    if (!formData?.PhoneNumber) {
      errors.PhoneNumber = "Phone number is required";
    }
    if (!formData?.Address || formData?.Address?.trim() === "") {
      errors.Address = "Address is required";
    }
    if (!formData?.Query || formData?.Query?.trim() === "") {
      errors.Query = "Query is required";
    }

    // If there are errors, set them and return false
    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);

      return false;
    }

    // If no errors, clear the error messages and return true
    setErrorMessage({
      Username: "",
      UserEmail: "",
      PhoneNumber: "",
      Address: "",
      Query: "",        
    });
    return true;
  };
  const handleContactUs = () => {
    if (!Validations()) return;
    const data = {
      Username: formData?.Username,
      UserEmail: formData?.UserEmail,
      PhoneNumber: formData?.PhoneNumber,
      Address: formData?.Address,
      Query: formData?.Query,
      BannerId:promotionalDetail?.Id,
    };

    const options = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/Customer/UserQueriesAgainstPromotionalBanners`,
    };
    axios(options)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
          setFormData({
            Username: "",
            UserEmail: "",
            PhoneNumber: "",
            Address: "",
            Query: "",
            BannerId: "",
          });
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
      })
      .catch((error) => {});
  };
  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      {loading === "getPro" ? (
        <div className="loading-container">
          <Loader />
        </div>
      ) : null}
      <Header 
          setLoading={setLoading}
          setLoginToken={setLoginToken}
          />
      <PromotionalBannerDetailComponent
        formData={formData}
        setFormData={setFormData}
        setErrorMessage={setErrorMessage}
        errorMessage={errorMessage}
        promotionalDetail={promotionalDetail}
        bannerUrl={bannerUrl}
        handleContactUs={handleContactUs}
      />
      <Footer />
    </div>
  );
};

export default PromotionalBannerDetail;
